import axios from 'axios';

// Create the instance
// Falls back to '/api' (relative) for unified deployments where client is served by the same server
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

// --- Added interceptor to request ---
api.interceptors.request.use(
  (config) => {
    // 1. Look for token in local storage
    const token = localStorage.getItem('token');
    
    // 2. If token exists, attach it to the header
    if (token) {
      config.headers['x-auth-token'] = token;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// --- Response interceptor: handle expired/invalid tokens ---
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const url = error.config?.url || '';
      const isAuthRoute = url.includes('/auth/login') || url.includes('/auth/register');
      if (!isAuthRoute && window.location.pathname !== '/login') {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);
// ----------------------------

export default api;
